module.exports = __webpack_public_path__ + "static/mh-task3-91afd37bbb986d1ed085fdb68b577466.jpg";